import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getPriceDiscountStyles = (rowAlignmentDirection, isLargeScreen) => {
  var _a, _b;
  var spacing = tokens.spacing;
  return StyleSheet.create({
    priceBreakUp: {
      justifyContent: 'space-between',
      flexDirection: isLargeScreen ? 'column' : 'row',
      marginBottom: isLargeScreen ? spacing.SPACING_0 : spacing.SPACING_16
    },
    discountedPrice: {
      justifyContent: 'space-between',
      flexDirection: isLargeScreen ? 'column' : 'row',
      marginBottom: isLargeScreen ? spacing.SPACING_0 : spacing.SPACING_20,
      marginLeft: isLargeScreen ? 40 : spacing.SPACING_0
    },
    leftTypographyContainer: Object.assign({}, !!rowAlignmentDirection && {
      flex: 1
    }),
    rightTypoGraphyContainer: Object.assign({}, !!rowAlignmentDirection && rowAlignmentDirection === 'row' ? {
      flexDirection: 'row',
      flex: 1
    } : {
      flex: 1,
      flexDirection: 'row-reverse'
    }),
    rightPriceSectionStyle: Object.assign(Object.assign(Object.assign(Object.assign({}, !!rowAlignmentDirection && rowAlignmentDirection === 'row' ? {
      flexDirection: 'row',
      alignItems: 'flex-end'
    } : {
      flexDirection: 'column',
      alignItems: 'flex-end'
    }), {
      flexDirection: isLargeScreen ? 'row' : 'column',
      justifyContent: 'space-between'
    }), isLargeScreen && {
      flex: 1
    }), {
      marginTop: isLargeScreen ? spacing.SPACING_8 : spacing.SPACING_0
    }),
    priceTypography: {
      marginBottom: isLargeScreen ? spacing.SPACING_0 : (_a = tokens === null || tokens === void 0 ? void 0 : tokens.spacing) === null || _a === void 0 ? void 0 : _a.SPACING_4,
      marginRight: isLargeScreen ? spacing.SPACING_8 : (_b = tokens === null || tokens === void 0 ? void 0 : tokens.spacing) === null || _b === void 0 ? void 0 : _b.SPACING_0
    },
    infoIcon: {
      marginLeft: tokens.spacing.SPACING_4,
      marginBottom: tokens.spacing.SPACING_4
    }
  });
};